import { useAuthStore } from '@/stores/auth-store';

export const useIsPlatformAdmin = (): boolean =>
  useAuthStore((state) => state.user?.platformRole) === 'platform_admin';
